import { render, staticRenderFns } from "./EmbryoGainTable.vue?vue&type=template&id=682bd412&"
import script from "./EmbryoGainTable.vue?vue&type=script&lang=js&"
export * from "./EmbryoGainTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports